import LessonComponentService from '../../../services/LessonComponentService';
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import { TableComponent } from '../../../models/LessonComponent';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableRowItem } from '../../../models/LessonComponentContent';
import useThemes from '../../../../shared/hooks/useThemes';

interface TableViewProps {
  component: TableComponent;
}

export const TableComponentView = (props: TableViewProps) => {
  const header: TableRowItem = props.component.content.table?.header;
  const rows = props.component.content.table.rows || [];
  const { borderColor, dataBgColor, headerBgColor } =
    props.component.settings.tableSettings;
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;
  const paragraphStyle = muiTheme.typography.custom1;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {header?.cells.map((cell, index) => (
              <TableCell
                key={cell.id}
                style={{
                  ...LessonComponentService.tableRowBorderStyle(
                    borderColor,
                    index,
                    headerBgColor,
                    true
                  ),
                  ...paragraphStyle,
                  verticalAlign: 'top'
                }}
              >
                <span
                  className="ql-editor"
                  dangerouslySetInnerHTML={{
                    __html: LessonComponentService.getUrlWithSas(cell.text)
                  }}
                ></span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <TableRow key={row.id}>
              {row.cells.map((cell, cellIndex) => (
                <TableCell
                  key={cellIndex}
                  style={{
                    ...LessonComponentService.tableRowBorderStyle(
                      borderColor,
                      cellIndex,
                      dataBgColor
                    ),
                    ...paragraphStyle
                  }}
                >
                  <span
                    className="ql-editor"
                    dangerouslySetInnerHTML={{
                      __html: LessonComponentService.getUrlWithSas(cell.text)
                    }}
                  ></span>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
